if (!customElements.get('wls-single-f-strength')) {
  class WLSSingleFStrength extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        progressBarContainer: 'js-progress-bar-container',
        progressBarFill: 'js-progress-bar-fill',
        progressBarIcon: 'js-progress-bar-icon',
      };

      this.selectors = {
        progressBarContainer: this.querySelector(`.${this.classes.progressBarContainer}`),
        progressBarFill: this.querySelector(`.${this.classes.progressBarFill}`),
        progressBarIcon: this.querySelector(`.${this.classes.progressBarIcon}`),
      };
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     *
     * @returns {void}
     */
    connectedCallback() {
      if (!this.selectors.progressBarContainer) return;

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.setupProgressBar();
              obs.unobserve(entry.target); // Trigger only once
            }
          });
        },
        {
          threshold: 0.4, // Adjust based on how visible the bar should be before animation
        }
      );

      observer.observe(this.selectors.progressBarContainer);
    }
    /**
     * Setup Progress Bar.
     *
     * @returns {void}
     */
    setupProgressBar() {
      const progressBarValue = parseInt(
        this.selectors.progressBarContainer.getAttribute('data-progress-bar-value'),
        10
      );
      const maxValue = parseInt(this.selectors.progressBarContainer.getAttribute('data-progress-bar-max-value'), 10);
      const minValue = parseInt(this.selectors.progressBarContainer.getAttribute('data-progress-bar-min-value'), 10);
      if (!isNaN(progressBarValue) && !isNaN(maxValue)) {
        this.animateProgressBar(progressBarValue, maxValue, minValue);
      } else {
        console.error('Invalid progress bar values!');
      }
    }

    /**
     * Animate Progress Bar.
     *
     * @param {number} progressBarValue - current value for progress bar
     * @param {number} maxValue - max valu for progress bar
     */
    animateProgressBar(progressBarValue, maxValue, minValue) {
      const value = progressBarValue - minValue;
      const range = maxValue - minValue;

      const progressPercentage = (value / range) * 100;

      this.selectors.progressBarFill.style.width = `${progressPercentage}%`;
      this.selectors.progressBarIcon.style.left = `${progressPercentage}%`;

      this.selectors.progressBarFill.style.transition = 'width 2s ease-in-out';
      this.selectors.progressBarIcon.style.transition = 'left 2s ease-in-out';
    }
  }

  window.customElements.define('wls-single-f-strength', WLSSingleFStrength);
}
